module.exports = __webpack_public_path__ + "img/cb-expand-history.3712a23c.svg";